// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__ldqbb","info":"UpdateTermsInfo_info__22L4g"};